import { createReducer, on } from '@ngrx/store';
import { ScatterPlotChartOptionValue } from 'ChartApp/ts/enums/scatter-plot-common.enum';
import { setScatterPlot } from '../scatter-plot.actions';
import { setChartOption } from './chart-options.actions';
export const displayCurrencyCodeInLegend = createReducer(false, on(setChartOption, (state, action) => {
    if (action.chartOption.value === ScatterPlotChartOptionValue.displayCurrencyCodeInLegend) {
        return action.chartOption.selected;
    }
    return state;
}), on(setScatterPlot, (state, action) => {
    return action.scatterPlot.displayCurrencyCodeInLegend;
}));
